import axios, { AxiosResponse } from "axios";
import { API_ROUTES } from "../constants";

export const getAirportData = (value: string): Promise<AxiosResponse> => {
  return axios.get(`${API_ROUTES.airports}/${value}`);
};

export const getAirlineData = (value: string): Promise<AxiosResponse> => {
  return axios.get(`${API_ROUTES.airlines}/${value}`);
};

export const getCountryData = (value: string): Promise<AxiosResponse> => {
  return axios.get(`${API_ROUTES.countries}/${value}`);
};